import { APIAuthSetup } from "./APIAuthSetup";
import { auth0Config } from "@app/config/auth0";
import type { AppState } from "@auth0/auth0-react";
import { Auth0Provider } from "@auth0/auth0-react";
import type { PropsWithChildren, ReactElement, ReactNode } from "react";
import { useNavigate } from "react-router";

interface AuthenticationProviderProps {
  children: ReactNode;
}

export const AuthenticationProvider = ({
  children
}: PropsWithChildren<AuthenticationProviderProps>): ReactElement | null => {
  const navigate = useNavigate();

  const onRedirectCallback = async (appState?: AppState) => {
    await navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider {...auth0Config} onRedirectCallback={onRedirectCallback}>
      <APIAuthSetup>{children}</APIAuthSetup>
    </Auth0Provider>
  );
};
